import { getDefinitionByName } from '@legacy-modules/common/util/kpiDefinitions';
import { PositiveDirection } from '@legacy-modules/metrics2/models/entities/PositiveDirection';
import ValueExpression, {
  TargetValueType,
} from '@legacy-modules/valueexpressions/models/valueexpressions/ValueExpression';

export default new ValueExpression({
  identifier: 'zustellzeit_ps_netto_avg',
  label: 'Ø Netto-PS-Zeit',
  definition: getDefinitionByName('Netto-PS-Zeit'),
  positiveDirection: PositiveDirection.custom,
  valueFormat: '-#.###.##0,0 h',
  valueQuotient: 3600,
  targetValueType: TargetValueType.QUOTE,
  decimalPlaces: 2,
});
